module.exports = __webpack_public_path__ + "img/download-background.27a5f24c.png";